"use strict";Object.defineProperty(exports, "__esModule", {value: true});var _toolkit = require('@reduxjs/toolkit');

var _user = require('shared/selectors/user');
var _common = require('./common');
var _unread = require('shared/services/unread');

 const selectIsMarkedUnreadByMe = _toolkit.createSelector.call(void 0, 
  _common.selectBlobjectByKey,
  _user.selectCurrentUserKey,
  (blobject, userKey) => !!blobject && _unread.isMarkedUnreadByMe.call(void 0, blobject, userKey),
); exports.selectIsMarkedUnreadByMe = selectIsMarkedUnreadByMe
